import React from "react";
import Sidenav from "./components/Sidenav";
import Getorders from "./components/orders/getorders";

function Orders( ) {
    
  return (
    <div className="flex ">
       <div className="">
       <Sidenav />
       </div>
        <div className="">
            <Getorders />
        </div>
    </div>
  );
}

export default Orders;
